/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESFund' store object.
 * @namespace ACESFundSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESFund';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESFundSelectors
   */
  static fetchCheckfundExhausted = state =>
    state[selectors.moduleIdentifier].fetchCheckfundExhausted.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESFundSelectors
   */
  static isFetchingFetchCheckfundExhausted = state =>
    state[selectors.moduleIdentifier].isFetchingFetchCheckfundExhausted.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESFundSelectors
   */
  static fetchCheckfundExhaustedError = state =>
    state[selectors.moduleIdentifier].fetchCheckfundExhaustedError.payload;
}
